import { TBC } from '@larki/shared/type/quote';
import text, { formatCurrencyForQuote } from '@/text';
import React from 'react';
import { _2dMapQuote } from '@larki/shared/type/order.v2';
import { useEditablePrice } from '@/mp/components/Cart/StaffPriceEditContext';
import EditablePriceField from '@/mp/components/Cart/StaffPriceEditor/EditablePriceField';

interface ItemProps {
  product: string;
  productKey?: string;
  subtotal: number | TBC;
  index: number;
  quote: _2dMapQuote;
  fullPrice: number | TBC;
  discount: number | TBC;
  isApproximate?: boolean;
}

const Item: React.FC<ItemProps> = ({
  product,
  productKey,
  subtotal,
  index,
  quote,
  fullPrice,
  discount,
  isApproximate = false,
}) => {
  const edit = useEditablePrice(productKey, subtotal);

  return (
    <div className='d-flex flex-column' key={`${product}-${index}`}>
      <div className='d-flex flex-row justify-content-between align-items-center'>
        <p className='mb-0'>{product}</p>
        {edit.isEditing ? (
          <EditablePriceField
            fieldKey={`rfq-edit-${productKey}`}
            value={edit.editableValue}
            originalValue={edit.originalValue}
            scaleFactor={quote.currency.scale_factor}
            onChange={edit.setOverride}
            hasActiveOverride={edit.hasActiveOverride}
            product={productKey!}
          />
        ) : (
          <p className='mb-0 justify-content-end'>
            {formatCurrencyForQuote(
              subtotal,
              quote.currency.name,
              quote.currency.scale_factor,
              { approximate: isApproximate, spaced: true }
            )}
          </p>
        )}
      </div>

      {discount !== 'TBC' && discount > 0 && (
        <p className='mb-0 d-flex flex-fill pl-3 font-12 font-grey--3'>
          <span className='text-decoration-line-through mr-1'>
            {text('fullPrice', {
              totalAmount: formatCurrencyForQuote(
                fullPrice,
                quote.currency.name,
                quote.currency.scale_factor,
                { spaced: true }
              ),
            })}
            ,
          </span>
          <span className='pl-1'>
            {text('savingAmount', {
              saving: formatCurrencyForQuote(
                discount,
                quote.currency.name,
                quote.currency.scale_factor,
                { spaced: true }
              ),
            })}
          </span>
        </p>
      )}
    </div>
  );
};

export default React.memo(Item);
